<template>
  <v-list>
    <v-card-title flat v-for="(item, index) in lists" :key="index" :class="index > 0 ? 'list-li' : 'list-li-top'" style="cursor: auto">
      <div class="pt-2 mb-3 list-title-wrap ellipsis">
        <v-text-field solo readonly hide-details placeholder="タイトルを入力してください。" class="fs-14 fw-bold black--text" v-model="item.title"></v-text-field>
        <div class="message-content-wrap list-description">{{ item.description }}</div>
      </div>
      <v-img class="list-img" cover v-if="item.image.url" :src="item.image.url"></v-img>
      <v-btn v-if="isShowButton(item)" outline color="#045ab8" class="mx-1 mb-3 fs-14 br-5" @click="openExternalPage(item.button.url)">{{ item.button.text}} &nbsp;></v-btn>
    </v-card-title>
  </v-list>
</template>

<script>
export default {
  name: 'scenario_item_lists',
  props: [
    'lists'
  ],
  data () {
    return {
    }
  },
  methods: {
    isShowButton (item) {
      return (item.button.url && item.button.text)
    },
    openExternalPage (url) {
      window.open(url, '_blank')
    },
    itemStyle (index) {
      let marginTop = index > 0 ? '5px;' : '0px;'
      return 'display: flex; margin-top: ' + marginTop
    }
  }
}
</script>

<style scoped>
  @import url("../../../../../menus/chatbot/fragments/fragments/css/chatbot_editor.css");
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/scenario/item/scenario_item_lists.vue